import IMAdjustmentForm from './IMAdjustmentForm';
export default IMAdjustmentForm;
